import { getFlatTranslations } from '../helpers';
import { hasMaxLength, isNotEmpty } from '../../../hooks/formValidator/validators';
import { APP_LANGUAGES } from '../../../app.config.vars/languages';
import { validateAnswers } from './SelectionTask/helpers';
export const validateAllFields = ({ validateAll, formState, customInputSchema, newValidation = true, }) => {
    const flatTitleTranslations = getFlatTranslations({
        translations: formState.titleTranslations,
        fieldName: 'title',
    });
    const flatDescriptionTranslations = getFlatTranslations({
        translations: formState.descriptionTranslations,
        fieldName: 'description',
    });
    return validateAll({
        inputValues: {
            ...flatTitleTranslations,
            ...flatDescriptionTranslations,
            ...(formState.selectedTaskType === 'location'
                ? {
                    coordinatesLat: String(formState.coordinatesLat),
                    coordinatesLon: String(formState.coordinatesLon),
                    radius: String(formState.radius),
                }
                : {}),
            successPoints: String(formState.successPoints),
            failurePoints: String(formState.failurePoints),
        },
        selectValues: {
            taskType: !!formState.selectedTaskType,
        },
        customInputSchema,
        context: {
            translations: flatDescriptionTranslations,
        },
        newValidation: newValidation,
    });
};
export const validateAsDraft = ({ validateAll, formState, customInputSchema, }) => {
    return validateAll({
        inputValues: {
            ...(formState.selectedTaskType === 'location'
                ? {
                    coordinatesLat: String(formState.coordinatesLat),
                    coordinatesLon: String(formState.coordinatesLon),
                    radius: String(formState.radius),
                }
                : {}),
            successPoints: String(formState.successPoints),
            failurePoints: String(formState.failurePoints),
        },
        selectValues: {
            taskType: !!formState.selectedTaskType,
        },
        customInputSchema,
    });
};
export const validateUpdatedFormFieldsAsDraft = ({ validateInputField, updatedFormFields, formState, refs, customInputSchema, }) => {
    let errors = [];
    if (formState.selectedTaskType === 'location') {
        if (updatedFormFields.has('coordinatesLat')) {
            const coordinatesLatError = validateInputField({
                fieldName: 'coordinatesLat',
                value: String(formState.coordinatesLat),
                customInputSchema,
            });
            if (coordinatesLatError) {
                errors.push(refs.coordinatesLat);
            }
        }
        if (updatedFormFields.has('coordinatesLon')) {
            const coordinatesLonError = validateInputField({
                fieldName: 'coordinatesLon',
                value: String(formState.coordinatesLon),
                customInputSchema,
            });
            if (coordinatesLonError) {
                errors.push(refs.coordinatesLon);
            }
        }
        if (updatedFormFields.has('radius')) {
            const radiusError = validateInputField({
                fieldName: 'radius',
                value: String(formState.radius),
                customInputSchema,
            });
            if (radiusError) {
                errors.push(refs.radius);
            }
        }
    }
    if (updatedFormFields.has('successPoints')) {
        const successPointsError = validateInputField({
            fieldName: 'successPoints',
            value: String(formState.successPoints),
            customInputSchema,
        });
        if (successPointsError) {
            errors.push(refs.successPoints);
        }
    }
    if (updatedFormFields.has('failurePoints')) {
        const failurePointsError = validateInputField({
            fieldName: 'failurePoints',
            value: String(formState.failurePoints),
            customInputSchema,
        });
        if (failurePointsError) {
            errors.push(refs.failurePoints);
        }
    }
    return errors;
};
export const validateAnswersBeforeSubmit = ({ taskAnswers, selectedTaskType, validateAll, setTaskAnswersError, }) => {
    const taskAnswersValidationSchema = {};
    taskAnswers.forEach((_, index) => {
        APP_LANGUAGES.forEach(({ code }) => {
            taskAnswersValidationSchema[`answerContent${index + 1}${code.toUpperCase()}`] = [isNotEmpty];
        });
    });
    const inputValues = {};
    taskAnswers.forEach((answer, index) => {
        APP_LANGUAGES.forEach(({ code }) => {
            inputValues[`answerContent${index + 1}${code.toUpperCase()}`] =
                answer.translations[code];
        });
    });
    const answerErrors = validateAll({
        inputValues,
        customInputSchema: taskAnswersValidationSchema,
        newValidation: false,
    });
    validateAnswers({
        taskType: selectedTaskType,
        taskAnswers: taskAnswers,
        setTaskAnswersError,
    });
    return answerErrors;
};
export const validateInputTaskAnswersBeforeSubmit = ({ inputTaskAnswers, validateAll, }) => {
    const inputTaskAnswersValidationSchema = {};
    inputTaskAnswers.forEach((_, index) => {
        APP_LANGUAGES.forEach(({ code }) => {
            inputTaskAnswersValidationSchema[`inputAnswer${index + 1}${code.toUpperCase()}`] = [
                isNotEmpty,
                hasMaxLength(64),
            ];
        });
    });
    const inputValues = {};
    inputTaskAnswers.forEach((answer, index) => {
        APP_LANGUAGES.forEach(({ code }) => {
            inputValues[`inputAnswer${index + 1}${code.toUpperCase()}`] =
                answer.translations[code];
        });
    });
    return validateAll({
        inputValues,
        customInputSchema: inputTaskAnswersValidationSchema,
        newValidation: false,
    });
};
